
























import { Component, Prop, Vue } from 'vue-property-decorator';
import store from '@/store';
import { getModule } from 'vuex-module-decorators';
import { ThemeConfModule } from '@/store/modules/theme';
import { ThemeConf } from '@/types/ThemeConf';
import { localize } from '@/filters/localize';
var sanitizeUrlHelper = require('@braintree/sanitize-url').sanitizeUrl;
const Theme = getModule(ThemeConfModule, store);

@Component
export default class ThemedSlide extends Vue {
  @Prop() enableScrollIndication!: boolean;

  get themeConfig() :ThemeConf | null{
    return Theme.getTheme;
  }

  get cssVars() {
    return this.themeConfig && this.themeConfig.color_primary
      ? { color: this.themeConfig.color_primary }
      : {};
  }

  sanitizeUrl(url: string) {
    return sanitizeUrlHelper(url);
  }

  getDefaultLinkDescription(displayText: string){
    return displayText ?? localize('Review');
  }
}
